<script setup lang="ts">
import AppPage from '@/components/app-page'

defineOptions({
  name: 'AppView',
})
</script>

<template>
  <AppPage />
</template>
